// extracted by mini-css-extract-plugin
export default {"link":"PageStartLink_link__HJcuH"};